export const numberToCurrency = (number, scope = 'individual') => {
  let options = { style: 'currency', currency: 'EUR', minimumFractionDigits: 0 };
  if (scope === 'global') {
    options.notation = 'compact';
    options.compactDisplay = 'short';
  }
  return new Intl.NumberFormat('fr-FR', options).format(Number(number).toFixed(0));
};

export const numberToPercentage = (number) =>
  number.toLocaleString('en', { style: 'percent', minimumFractionDigits: 2 });

export const createDiagonalPattern = (color = 'black') => {
  // create a 10x10 px canvas for the pattern's base shape
  let shape = document.createElement('canvas');
  shape.width = 10;
  shape.height = 10;
  // get the context for drawing
  let c = shape.getContext('2d');
  // draw 1st line of the shape
  c.strokeStyle = color;
  c.beginPath();
  c.moveTo(2, 0);
  c.lineTo(10, 8);
  c.stroke();
  // draw 2nd line of the shape
  c.beginPath();
  c.moveTo(0, 8);
  c.lineTo(2, 10);
  c.stroke();
  // create the pattern from the shape
  return c.createPattern(shape, 'repeat');
};

export const colors = {
  distributions: '#447489',
  distributionsWaitingToBePaid: '#808080',
  calls: '#B9A76D',
  toBeCalled: '#447489',
  white: '#FFF',
  darkText: 'rgba(0,0,0,0.85)',
};

export const legendLabelsConfig = {
  boxWidth: 15,
  boxHeight: 15,
};

export const defaultXAxisGridConfig = {
  display: false,
  drawBorder: true,
  borderWidth: 1,
  borderColor: 'rgba(0,0,0,0.25)',
};
